<template>
    <section>
        <div class="row">
            <div id='loadingmessage'
                style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
                v-if="loading">
                <p style="position: absolute; color: White; top: 40%; left: 50%;">
                    <img src="../../assets/loader.gif" />
                </p>
            </div>
            <div class="col-12 grid-margin">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">My Profile &nbsp; <router-link :to='/editmyprofile/+this.id'><span><i
                                        style="color:blue!important" class="fa fa-edit"></i></span></router-link>
                        </h4>
                        <div class="row pt-4">
                            <div class="col-2 ">
                                <div class="row pl-3">
                                    <output class="flex md12">
                                        <img :src="image" v-if="image" style="width:150px;height:150px;" />
                                        <p v-else>No image...</p>
                                        <!-- <router-link :to="'/editmyprofile/'+this.userid"> <span class="flex md12 " align="right"><i class="fa fa-pencil"></i></span></router-link> -->
                                    </output>
                                </div>
                            </div>

                            <div class="col-6">
                                <table class="table table-white flex md8">
                                    <thead>
                                        <tr>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th scope="col"> Name</th>
                                            <td>{{name}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">username</th>
                                            <td>{{username}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Email ID</th>
                                            <td>{{email}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Mobile Number</th>
                                            <td>{{phone}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="col">Organization</th>
                                            <td>{{organization}}</td>
                                        </tr>
                                        <tr v-if="occupation">
                                            <th  scope="col">Occupation</th>
                                            <td>{{occupation}}</td>
                                        </tr>


                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    export default {
        name: 'myprofile',

        data() {
            return {
                username: '',
                name: '',
                password: '',
                oldpassword: '',
                phone: '',
                email: '',
                organization: '',
                occupation: '',
                image: null,
                id: '',

                loading: false,
                data: [],
            }
        },
        mounted: function () {
            this.getview()
        },

        methods: {
            getview() {
                this.visible = true
                axios({
                    method: 'GET',
                    url: '/user/profile',
                    params: { 'token': localStorage.getItem('token') }
                })
                    .then(response => {
                        if (response.data.status === true) {
                            this.username = response.data.data.username
                            this.name = response.data.data.name
                            this.email = response.data.data.email
                            this.phone = response.data.data.phone
                            this.occupation = response.data.data.occupation
                            this.organization = response.data.data.organization
                            this.id = response.data.data._id
                            this.image =
                                'http://13.232.14.77/u/' + response.data.data.photo
                            this.visible = false
                        } else if (response.data.status === false) {
                            this.visible = false
                        }
                    })
                    .catch(err => {
                        this.errors.push(err)
                        alert('No Network Found!!')
                    })
            },
        },
    }
</script>
<style>
    .circular--square {
        border-top-left-radius: 50% 50%;
        border-top-right-radius: 50% 50%;
        border-bottom-right-radius: 50% 50%;
        border-bottom-left-radius: 50% 50%;
    }
</style>